import { injectScript } from './script-loader.service';

export const initializeGTM = (gtmId: string): boolean => {
  if (!gtmId) return false;
  
  try {
    // Inicializa o dataLayer
    window.dataLayer = window.dataLayer || [];
    
    // Injeta o script do GTM
    const gtmScript = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${gtmId}');
    `;
    
    injectScript(gtmScript);
    return true;
  } catch (error) {
    console.error(`❌ GTM - Erro ao inicializar ${gtmId}:`, error);
    return false;
  }
}; 